"use client";

import Link from "next/link";
import AnalysisDate from "~/src/components/feature/analysis/info/AnalysisDate";
import Creator from "~/src/components/feature/analysis/info/Creator";
import Favorit from "~/src/components/feature/analysis/info/Favorit";
import WorkList from "~/src/components/feature/analysis/info/WorkList";
import { getDetailAnalysisUrl } from "~/src/lib/ui/transition";
import { HeadingAnalysisArticle } from "~/src/type/ui/article/article";

export type AnalysisHeadingProps = {
  liked: boolean;
  article: HeadingAnalysisArticle;
};

/**
 * 分析記事カード
 */
export default function AnalysisHeading({ liked, article }: AnalysisHeadingProps) {
  const { id, contents } = article;

  //------------
  // 遷移先
  //------------
  const url = getDetailAnalysisUrl(id);

  return (
    <article className="group relative flex max-w-192 flex-col overflow-hidden rounded-lg border border-GRAY_3 bg-WHITE_1 px-5 py-3 shadow-sm transition-all duration-300 hover:border-PRIMARY/40 hover:shadow-md">
      <span className="pointer-events-none absolute inset-0 -z-0 opacity-0" />
      <Link href={url}>
        <AnalysisDate
          create={contents.createdAt}
          update={contents.updatedAt}
        />
        <h2 className="line-clamp-2 text-base font-bold text-BLACK_1">{contents.title}</h2>
        <WorkList works={contents.works} />
        <Creator name={contents.userName} />
        <div className="mt-2 flex space-x-2">
          <Favorit
            isFavorit={liked}
            analysisId={id}
            contents={contents}
          />
          {/* <Bookmark isBookmark={contents.isBookmark} /> */}
        </div>
      </Link>
    </article>
  );
}
